import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DealerPage = lazy(() => import('../pages/dealer/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const IndustryDetailPage = lazy(() => import('../pages/industries/detail/page'));
const QuotationPage = lazy(() => import('../pages/quotation/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/product',
    element: <ProductPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/industries/:industryId',
    element: <IndustryDetailPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/quotation',
    element: <QuotationPage />,
  },
  {
    path: '/dealer',
    element: <DealerPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;